export const SliderLeftHandleSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="20" height="20">
  <style>
    .bg{fill:#fff}
    .outline{fill:#666}
    .focus .outline{fill:#3498db}
    .active .outline{fill:#333}
    .disabled .bg{fill:#ebebeb}
    .disabled .outline{fill:#b4b4b4}
  </style>
  <path class="bg" d="M11.2,2.5c-4.3,0-7.7,3.3-7.7,7.5s3.5,7.5,7.8,7.5h4.3v-15H11.2z"/>
  <path class="outline" d="M15,3v14h-3.6C7.3,17,4,13.9,4,10s3.3-7,7.4-7H15 M16,2h-4.6C6.7,2,3,5.6,3,10s3.7,8,8.4,8H16V2 L16,2z"/>
</svg>`;
